import {
  type Device,
  type DeviceEvent,
  type DeviceEventName,
  type DeviceEventProperties,
} from '../types/deviceEvents.type';
import { buildDeviceEventPayload } from './deviceEventsPayload.util';

let trackCallback: ((event: DeviceEvent) => void) | null = null;

export const registerTrackCallback = (fn: (event: DeviceEvent) => void): void => {
  trackCallback = fn;
};

export const clearTrackCallback = (): void => {
  trackCallback = null;
};

export const publish = <D extends Device, E extends DeviceEventName<D>>(
  device: D,
  name: E,
  ...rest: DeviceEventProperties<D, E> extends undefined
    ? []
    : [properties: DeviceEventProperties<D, E>]
): void => {
  if (!trackCallback) return;
  const properties = rest[0];
  trackCallback(buildDeviceEventPayload(device, name, properties));
};

export const devicePublisher =
  <D extends Device>(device: D) =>
  <E extends DeviceEventName<D>>(
    name: E,
    ...rest: DeviceEventProperties<D, E> extends undefined
      ? []
      : [properties: DeviceEventProperties<D, E>]
  ): void => {
    publish(device, name, ...rest);
  };
